import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useCart } from '../context/CartContext';

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [showNotification, setShowNotification] = useState(false);

  const products = {
    1: {
      id: 1,
      name: 'Premium Wandverkleidung',
      description: 'Hochwertige Wandverkleidung aus edlen Materialien für anspruchsvolle Innenräume. Perfekte Oberflächenbearbeitung mit langlebiger Schutzschicht.',
      fullDescription: 'Unsere Premium Wandverkleidung vereint Ästhetik und Funktionalität auf höchstem Niveau. Hergestellt aus sorgfältig ausgewählten Materialien, bietet sie nicht nur eine beeindruckende Optik, sondern auch hervorragende technische Eigenschaften. Die spezielle Oberflächenbehandlung garantiert Langlebigkeit und einfache Pflege. Ideal für Wohn- und Geschäftsräume, die besonderen Wert auf Qualität legen. Die Verkleidung ist in verschiedenen Farbtönen erhältlich und lässt sich perfekt in jedes Raumkonzept integrieren.',
      price: 1299.99,
      image: '/images/1.jpg'
    },
    2: {
      id: 2,
      name: 'Luxus Bodenbeschichtung',
      description: 'Professionelle Bodenbeschichtung mit hervorragender Haltbarkeit und elegantem Finish. Ideal für gewerbliche und private Bereiche.',
      fullDescription: 'Die Luxus Bodenbeschichtung von Lackfertighaus setzt neue Maßstäbe in Sachen Widerstandsfähigkeit und Design. Diese innovative Beschichtung wurde speziell für Bereiche mit hoher Beanspruchung entwickelt und bietet außergewöhnliche Beständigkeit gegen Abrieb, Chemikalien und mechanische Belastung. Die elegante Oberfläche ist nicht nur optisch ansprechend, sondern auch äußerst pflegeleicht. Perfekt geeignet für Industriehallen, Büros, Verkaufsräume sowie private Wohnbereiche. Die Beschichtung ist rutschfest und erfüllt alle Sicherheitsstandards.',
      price: 1899.99,
      image: '/images/2.jpg'
    },
    3: {
      id: 3,
      name: 'Designer Deckenverkleidung',
      description: 'Exklusive Deckenverkleidung mit modernster Technik und zeitlosem Design. Schalldämmend und wärmeregulierend.',
      fullDescription: 'Unsere Designer Deckenverkleidung kombiniert ästhetische Eleganz mit fortschrittlicher Technologie. Das speziell entwickelte Material bietet hervorragende akustische Eigenschaften und trägt zur Verbesserung des Raumklimas bei. Die Installation ist dank des durchdachten Systems einfach und schnell durchführbar. Die Verkleidung ist in verschiedenen Designs erhältlich und kann sowohl in modernen als auch in klassischen Innenräumen eingesetzt werden. Zusätzlich bietet sie eine integrierte Wärmedämmung, die zur Energieeffizienz des Gebäudes beiträgt.',
      price: 1599.99,
      image: '/images/3.jpg'
    },
    4: {
      id: 4,
      name: 'Spezial Fassadenlack',
      description: 'Wetterbeständiger Fassadenlack mit UV-Schutz und selbstreinigender Oberfläche. Für langanhaltende Farbbrillanz.',
      fullDescription: 'Unser Spezial Fassadenlack wurde speziell für extreme Witterungsbedingungen entwickelt und bietet maximalen Schutz für Ihre Außenfassade. Die innovative Formel mit UV-Schutz verhindert das Ausbleichen der Farben und sorgt für jahrelange Farbbrillanz. Die selbstreinigende Oberfläche minimiert den Pflegeaufwand erheblich, da Schmutz und Staub einfach durch Regenwasser abgewaschen werden. Der Lack ist atmungsaktiv, was Feuchtigkeitsprobleme verhindert und zur Langlebigkeit der Fassade beiträgt. Erhältlich in einer breiten Farbpalette.',
      price: 899.99,
      image: '/images/4.jpg'
    },
    5: {
      id: 5,
      name: 'Premium Holzschutz',
      description: 'Ökologischer Holzschutz mit Tiefenwirkung für Innen- und Außenbereiche. Schützt vor Feuchtigkeit und Schädlingen.',
      fullDescription: 'Unser Premium Holzschutz bietet umfassenden Schutz für Holzoberflächen im Innen- und Außenbereich. Die ökologische Formel dringt tief in die Holzfasern ein und schützt von innen heraus vor Feuchtigkeit, UV-Strahlung und Schädlingsbefall. Das Produkt ist frei von schädlichen Lösungsmitteln und daher besonders umweltfreundlich. Die natürliche Holzmaserung bleibt sichtbar und wird durch die Behandlung sogar betont. Ideal für Terrassen, Gartenmöbel, Fassaden und Innenholzarbeiten. Die Anwendung ist einfach und das Ergebnis langanhaltend.',
      price: 749.99,
      image: '/images/5.jpg'
    }
  };

  const product = products[id];

  if (!product) {
    return (
      <div className="product-detail-section">
        <h1>Produkt nicht gefunden</h1>
        <button onClick={() => navigate('/')} className="btn-primary">
          Zurück zur Startseite
        </button>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product);
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const handleBuyNow = () => {
    addToCart(product);
    navigate('/checkout');
  };

  return (
    <div className="product-detail-section">
      <Helmet>
        <title>{product.name} - Lackfertighaus</title>
        <meta name="description" content={product.description} />
        <meta property="og:title" content={product.name} />
        <meta property="og:description" content={product.description} />
        <meta property="og:image" content={`https://lackfertighaus.com${product.image}`} />
        <link rel="canonical" href={`https://lackfertighaus.com/product/${id}`} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": product.name,
            "image": `https://lackfertighaus.com${product.image}`,
            "description": product.description,
            "offers": {
              "@type": "Offer",
              "price": product.price,
              "priceCurrency": "EUR"
            }
          })}
        </script>
      </Helmet>

      {showNotification && (
        <div className="notification">
          Produkt wurde zum Warenkorb hinzugefügt!
        </div>
      )}

      <div className="product-detail-container">
        <div>
          <img 
            src={product.image} 
            alt={product.name} 
            className="product-detail-image"
          />
        </div>
        
        <div className="product-detail-info">
          <h1>{product.name}</h1>
          <p className="product-price">{product.price.toFixed(2)} €</p>
          <p>{product.fullDescription}</p>
          
          <div className="product-actions">
            <button onClick={handleAddToCart} className="btn-primary">
              In den Warenkorb
            </button>
            <button onClick={handleBuyNow} className="btn-secondary">
              Jetzt kaufen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;